import { LitElement, html, css } from 'lit-element';


class GaugeView extends LitElement {

  static get properties() {
    return {
      title: { type: String, reflect: true },
      value: { type: Number, reflect: true },
      maxValue: { type: Number, reflect: true, attribute: 'max-value' },
      gaugeWidth: { type: Number, reflect: true, attribute: 'gauge-width' },
      gaugeColor: { type: String, reflect: true, attribute: 'gauge-color' },
      fullCircle: { type: Boolean, reflect: true, attribute: 'full-circle' },
    };
  }

  constructor() {
    super();
    this.title = '';
    this.value = null;
    this.maxValue = null;
    this.fullCircle = false;
    this.gaugeWidth = 8;
    this.gaugeColor = 'black';
  }

  _inflate() {
    bb.generate({
      data: {
        columns: [[this.title, this.value]],
        type: 'gauge',
        color: (color, d) => this.gaugeColor,
      },
      gauge: {
        fullCircle: this.fullCircle,
        title: `${this.value}`,
        max: this.maxValue,
        width: this.gaugeWidth,
        label: { show: false },
      },
      bindto: this.shadowRoot.querySelector('#gauge'),
    });
  }

  static get styles() {
    return css`
      /* Billboard.js styles */
      .bb svg{font:10px sans-serif;-webkit-tap-highlight-color:rgba(0,0,0,0)}.bb line,.bb path{fill:none;stroke:#000}.bb .bb-button,.bb text{-webkit-user-select:none;-moz-user-select:none;user-select:none}.bb-bars path,.bb-event-rect,.bb-legend-item-tile,.bb-xgrid-focus,.bb-ygrid{shape-rendering:crispEdges}.bb-chart-arc path{stroke:#fff}.bb-chart-arc text{fill:#fff;font-size:13px}.bb-axis{shape-rendering:crispEdges}.bb-grid line{stroke:#aaa}.bb-grid text{fill:#aaa}.bb-xgrid,.bb-ygrid{stroke-dasharray:3 3}.bb-text.bb-empty{fill:grey;font-size:2em}.bb-line{stroke-width:1px}.bb-circle._expanded_{stroke-width:1px;stroke:#fff}.bb-selected-circle{fill:#fff;stroke-width:2px}.bb-bar{stroke-width:0}.bb-bar._expanded_{fill-opacity:.75}.bb-target.bb-focused{opacity:1}.bb-target.bb-focused path.bb-line,.bb-target.bb-focused path.bb-step{stroke-width:2px}.bb-target.bb-defocused{opacity:.3!important}.bb-region{fill:#4682b4;fill-opacity:.1}.bb-brush .extent,.bb-zoom-brush{fill-opacity:.1}.bb-legend-item{font-size:12px;user-select:none}.bb-legend-item-hidden{opacity:.15}.bb-legend-background{opacity:.75;fill:#fff;stroke:#d3d3d3;stroke-width:1}.bb-title{font:14px sans-serif}.bb-tooltip-container{z-index:10}.bb-tooltip{border-collapse:collapse;border-spacing:0;background-color:#fff;empty-cells:show;opacity:.9;-webkit-box-shadow:7px 7px 12px -9px #777;-moz-box-shadow:7px 7px 12px -9px #777;box-shadow:7px 7px 12px -9px #777}.bb-tooltip tr{border:1px solid #ccc}.bb-tooltip th{background-color:#aaa;font-size:14px;padding:2px 5px;text-align:left;color:#fff}.bb-tooltip td{font-size:13px;padding:3px 6px;background-color:#fff;border-left:1px dotted #999}.bb-tooltip td>span,.bb-tooltip td>svg{display:inline-block;width:10px;height:10px;margin-right:6px}.bb-tooltip.value{text-align:right}.bb-area{stroke-width:0;opacity:.2}.bb-chart-arcs-title{dominant-baseline:middle;font-size:1.3em}.bb-chart-arcs-gauge-title{dominant-baseline:middle;font-size:2.7em}.bb-chart-arcs .bb-chart-arcs-background{fill:#e0e0e0;stroke:none}.bb-chart-arcs .bb-chart-arcs-gauge-unit{fill:#000;font-size:16px}.bb-chart-arcs .bb-chart-arcs-gauge-max,.bb-chart-arcs .bb-chart-arcs-gauge-min{fill:#777}.bb-chart-arc .bb-gauge-value{fill:#000}.bb-chart-radars .bb-levels polygon{fill:none;stroke:#848282;stroke-width:.5px}.bb-chart-radars .bb-levels text{fill:#848282}.bb-chart-radars .bb-axis line{stroke:#848282;stroke-width:.5px}.bb-chart-radars .bb-axis text{font-size:1.15em;cursor:default}.bb-chart-radars .bb-shapes polygon{fill-opacity:.2;stroke-width:1px}.bb-button{position:absolute;top:10px;right:10px}.bb-button .bb-zoom-reset{font-size:11px;border:1px solid #ccc;background-color:#fff;padding:5px;border-radius:5px;cursor:pointer}

      /* Element styles */
      :host {
        --width: 200px;
        display: block;
      }
      :host([hidden]) { display: none }

      #container {
        text-align: center;
        font-size: var(--font-size);
      }

      #gauge {
        width: var(--width);
      }

      #title {
        text-transform: uppercase;
        margin-top: var(--padding-sm);
      }
    `;
  }

  updated() {
    this._inflate();
    return super.updated(...arguments);
  }

  render() {
    return html`
      <div id="container">
        <div id="gauge"><!--The gauge is inflated here--></div>
        <div id="title">${this.title}</div>
      </div>
    `;
  }
}
customElements.define('gauge-view', GaugeView);
